<template>
    <div class="colour-all">
        <div class="container">
            <h1>colours</h1>

            <div class="card">
                <ul class="list-group list-group-flush">
                    <li class="list-group-item" v-for="colour in colours" v-bind:class="{editing: editing(colour), images: editingImages(colour)}">
                        <div class="d-flex align-items-center">
                            <img v-if="colour.images && colour.images.swatch" :src="'https://s3.eu-west-2.amazonaws.com/ngb-mpdb/' + colour.images.swatch[0]" width="32" height="32" class="mr-2" />
                            <strong v-if="!editing(colour)">{{colour.name}} <span v-if="colour.prefix">({{colour.prefix}})</span></strong>
                            <b-form-input v-model="colour.name" v-if="editing(colour)" class="mr-4" placeholder="Full name (e.g. Red)"></b-form-input>
                            <b-form-input v-model="colour.prefix" v-if="editing(colour)" class="mr-4" placeholder="Prefix (e.g. R)"></b-form-input>

                            <div class="btn-group ml-auto">
                                <b-button type="button" class="mr-2" v-on:click="edit(colour)" v-if="!editing(colour) && !editingImages(colour)">
                                    Edit
                                </b-button>

                                <b-button type="button" class="mr-2" variant="success" v-on:click="save(colour)" v-if="editing(colour) || editingImages(colour)">
                                    Save
                                </b-button>

                                <b-button type="button" class="mr-2" variant="danger" v-on:click="del(colour)" v-if="editing(colour)">
                                    Delete
                                </b-button>

                                <b-button type="button" v-on:click="cancel()" v-if="editing(colour) || editingImages(colour)">
                                    Cancel
                                </b-button>

                                <b-button type="button" v-on:click="images(colour)" v-if="!editing(colour) && !editingImages(colour)">
                                    Images
                                </b-button>
                            </div>
                        </div>

                        <div class="mt-4" v-if="editingImages(colour)">
                            <h3>Swatch</h3>
                            <product-images v-bind:product="colour" type="swatch" editable="true" default-message="Upload colour swatch here" min-width="400" min-height="400" max-images="1"></product-images>
                        </div>
                    </li>
                </ul>
            </div>

            <b-button type="button" size="lg" class="ml-auto mr-auto mt-4 d-block" variant="success" v-on:click="create()">Create colour</b-button>
        </div>

        <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
    </div>
</template>

<script>
  import Simplert from 'vue2-simplert'
  import ProductImages from './ProductImages.vue'

  export default {
    name: 'colourAll',
    props: ['fb'],
    components: {
      Simplert,
      ProductImages
    },
    firebase () {
      return {
        colours: this.fb.database().ref('colours').orderByChild('name')
      }
    },
    data () {
      return {
        editingKey: null,
        editingImagesKey: null
      }
    },
    methods: {
      edit (colour) {
        this.editingImagesKey = null
        this.editingKey = colour['.key']
      },
      editing (colour) {
        return this.editingKey === colour['.key']
      },
      del (colour) {
        this.$firebaseRefs.colours.child(colour['.key']).remove()
        this.$refs.simplert.openSimplert({
          title: 'Deleted',
          type: 'info',
          message: 'The product colour and all associated images have been deleted'
        })
      },
      images (colour) {
        this.editingKey = null
        this.editingImagesKey = colour['.key']
      },
      editingImages (colour) {
        return this.editingImagesKey === colour['.key']
      },
      save (colour) {
        let f = this.fb.database().ref('colours/' + colour['.key'])
        delete colour['.key']
        if (!colour.prefix) {
          colour.prefix = ''
        }
        f.set(colour).then(() => {
          this.$refs.simplert.openSimplert({
            title: 'Saved',
            type: 'info',
            message: 'Saved'
          })

          this.cancel()
        })
      },
      cancel () {
        this.editingKey = null
        this.editingImagesKey = null
      },
      create () {
        let push = this.$firebaseRefs.colours.push({
          name: ''
        })
        let self = this
        push.then(() => {
          self.cancel()
          self.editingKey = push.key
        }, () => {
          console.error(arguments)
        })
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/ColourAll.vue